const zh_hant = {
  CreditCardInformation: "信用卡信息",
  CardNo: "信用卡號",
  periodofvalidity: "有效期",
  safetycode: "安全碼",
  CARDHOLDERNAME: "持卡人姓名",
  payment: "支付",
  Processinginprogress: "處理中...",
  UnableToLoad: "無法加載支付系統，請檢查網絡連接",
  Payment_system: "支付系統初始化失敗，請刷新頁面重試",
  The_payment: "支付系統已初始化完成",
  Stripe_initialization: "支付系統初始化失敗",
  Please_enter: "請輸入持卡人姓名",
  Processing_payment: "正在處理支付",
  Obtaining_payment: "正在獲取支付憑證",
  Unable_to: "無法獲取支付憑證",
  Confirming_payment: "正在確認支付",
  Payment_failed: "支付失敗",
  Payment_successful: "支付成功！支付ID",
  Payment_success: "支付成功",
  Payment_processing: "支付處理錯誤",
  Unknown_error: "支付處理過程中發生未知錯誤",
  Cancelling_payment: "正在取消支付...",
  CancelPayment: "取消支付",
  Payment_canceled: "支付已取消",
  order_status: "正在查詢訂單狀態...",
  Subscription_successful: "訂閱成功"
};

const zh_cn = {
  CreditCardInformation: "信用卡信息",
  CardNo: "信用卡号",
  periodofvalidity: "有效期",
  safetycode: "安全码",
  CARDHOLDERNAME: "持卡人姓名",
  payment: "支付",
  Processinginprogress: "处理中...",
  UnableToLoad: "无法加载支付系统，请检查网络连接",
  Payment_system: "支付系统初始化失败，请刷新页面重试",
  The_payment: "支付系统已初始化完成",
  Stripe_initialization: "支付系统初始化失败",
  Please_enter: "请输入持卡人姓名",
  Processing_payment: "正在处理支付",
  Obtaining_payment: "正在获取支付凭证",
  Unable_to: "无法获取支付凭证",
  Confirming_payment: "正在确认支付",
  Payment_failed: "支付失败",
  Payment_successful: "支付成功！支付ID",
  Payment_success: "支付成功",
  Payment_processing: "支付处理错误",
  Unknown_error: "支付处理过程中发生未知错误",
  Cancelling_payment: "正在取消支付...",
  CancelPayment: "取消支付",
  Payment_canceled: "支付已取消",
  order_status: "正在查询订单状态...",
  Subscription_successful: "订阅成功"
};

const en = {
  CreditCardInformation: "Credit Card Information",
  CardNo: "Card Number",
  periodofvalidity: "Expiry Date",
  safetycode: "Security Code",
  CARDHOLDERNAME: "Cardholder Name",
  payment: "Pay",
  Processinginprogress: "Processing...",
  UnableToLoad: "Unable to load payment system. Please check your network connection.",
  Payment_system: "Payment system failed to initialize. Please refresh the page and try again.",
  The_payment: "Payment system is ready.",
  Stripe_initialization: "Failed to initialize payment system.",
  Please_enter: "Please enter the cardholder name.",
  Processing_payment: "Processing payment...",
  Obtaining_payment: "Preparing payment...",
  Unable_to: "Failed to prepare payment.",
  Confirming_payment: "Confirming payment...",
  Payment_failed: "Payment failed.",
  Payment_successful: "Payment successful! Payment ID:",
  Payment_success: "Payment successful!",
  Payment_processing: "Payment processing error.",
  Unknown_error: "An unknown error occurred during payment.",
  Cancelling_payment: "Cancelling payment...",
  CancelPayment: "Cancel Payment",
  Payment_canceled: "Payment cancelled.",
  order_status: "Checking order status...",
  Subscription_successful: "Subscription successful!"
};

const es = {
  CreditCardInformation: "Información de la tarjeta de crédito",
  CardNo: "Número de tarjeta",
  periodofvalidity: "Fecha de caducidad",
  safetycode: "Código de seguridad",
  CARDHOLDERNAME: "Nombre del titular",
  payment: "Pagar",
  Processinginprogress: "Procesando...",
  UnableToLoad: "No se puede cargar el sistema de pago. Verifique su conexión a Internet.",
  Payment_system:
    "Error al inicializar el sistema de pago. Actualice la página e inténtelo de nuevo.",
  The_payment: "El sistema de pago está listo.",
  Stripe_initialization: "Error al inicializar el sistema de pago.",
  Please_enter: "Ingrese el nombre del titular de la tarjeta.",
  Processing_payment: "Procesando el pago...",
  Obtaining_payment: "Preparando el pago...",
  Unable_to: "No se pudo preparar el pago.",
  Confirming_payment: "Confirmando el pago...",
  Payment_failed: "El pago falló.",
  Payment_successful: "¡Pago exitoso! ID de pago:",
  Payment_success: "¡Pago exitoso!",
  Payment_processing: "Error al procesar el pago.",
  Unknown_error: "Ocurrió un error desconocido durante el pago.",
  Cancelling_payment: "Cancelando el pago...",
  CancelPayment: "Cancelar pago",
  Payment_canceled: "Pago cancelado.",
  order_status: "Consultando estado del pedido...",
  Subscription_successful: "¡Suscripción exitosa!"
};

export default {
  zh_hant,
  zh_cn,
  en,
  es
};
